import { useColorMode } from "@/components/layouts/ColorModeContext";
import { getTheme } from "@/features/branding";
import { App as AntdApp, ConfigProvider, theme as antdTheme } from "antd";
import en_GB from "antd/locale/en_GB";
import zh_CN from "antd/locale/zh_CN";
import zh_HK from "antd/locale/zh_HK";
import { merge } from "lodash/fp";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const locales = {
  "en-AU": en_GB,
  "zn-CN": zh_CN,
  "zh-HK": zh_HK
};
export const CustomConfigProvider = ({
  children
}: {
  children: any;
}) => {
  const {
    i18n
  } = useTranslation();
  const {
    colorMode
  } = useColorMode();
  const locale = i18n.language as keyof typeof locales;
  const theme = useMemo(() => {
    const {
      antd,
      antdDark
    } = getTheme();
    const isDark = colorMode === "dark";
    return {
      ...(isDark && antdDark ? merge(antd, antdDark) : antd),
      algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm
    };
  }, [colorMode]);
  return <ConfigProvider locale={locales[locale]} theme={theme} data-sentry-element="ConfigProvider" data-sentry-component="CustomConfigProvider" data-sentry-source-file="CustomConfigProvider.tsx">
      <AntdApp data-sentry-element="AntdApp" data-sentry-source-file="CustomConfigProvider.tsx">{children}</AntdApp>
    </ConfigProvider>;
};